/*
* author: liujianhong
*/
import { ajax } from '@/utils/request';

const api = {
    /**
     ***************** 报表管理 *****************
    */
    // 获取班组借支表-分页
    getFinanceTeamloanReportPage(data: any) {
        return ajax({
            method: 'get',
            url: `report/labour-payment-page`,
            data
        })
    },
    // 获取班组借支表-统计数据
    getFinanceTeamloanReportCount(data: any) {
        return ajax({
            method: 'get',
            url: `report/labour-payment-sum`,
            data
        })
    },
    // 获取班组借支表-导出
    getFinanceTeamloanReportExport(data: any) {
        return ajax({
            method: 'get',
            url: `report/labour-payment-export`,
            type: "blob",
            data
        })
    },
    // 获取班组借支表-班组材料支付明细
    getFinanceTeamloanReportByTeamPayDetail(data: any) {
        return ajax({
            method: 'get',
            url: `report/labour-payment-detail`,
            data
        })
    },
    // 单包材料汇总表-列表
    getFinanceSingleMaterialPage(data: any){
        return ajax({
            method: 'get',
            url: `report/single-material-pick`,
            data
        })
    },
    // 单包材料汇总表-导出
    getFinanceSingleMaterialExport(data: any){
        return ajax({
            method: 'get',
            url: `report/single-material-pick-export`,
            type: "blob",
            data
        })
    },
    // 单包材料汇总表-明细列表
    getFinanceSingleMaterialDetailPage(data: any){
        return ajax({
            method: 'get',
            url: `report/single-material-pick-detail`,
            data
        })
    },
    // 单包材料汇总表-明细列表统计数据
    getFinanceSingleMaterialDetailCount(data: any){
        return ajax({
            method: 'get',
            url: `report/single-material-pick-detail-sum`,
            data
        })
    },
    // 单包材料汇总表-明细列表导出
    getFinanceSingleMaterialDetailExport(data: any){
        return ajax({
            method: 'get',
            url: `report/single-material-pick-detail-export`,
            type: "blob",
            data
        })
    },
    // 供应商付款汇总表-列表
    getFinanceSupplierPaymentPage(data: any){
        return ajax({
            method: 'get',
            url: `report/supplier-pay`,
            data
        })
    },
    // 供应商付款汇总表-统计
    getFinanceSupplierPaymentCount(data: any){
        return ajax({
            method: 'get',
            url: `report/supplier-pay-sum`,
            data
        })
    },
    // 供应商付款汇总表-导出
    getFinanceSupplierPaymentExport(data: any){
        return ajax({
            method: 'get',
            url: `report/supplier-pay-export`,
            type: "blob",
            data
        })
    },
    // 供应商付款汇总表-明细列表
    getFinanceSupplierPaymentDetailPage(data: any){
        return ajax({
            method: 'get',
            url: `report/supplier-pay-detail`,
            data
        })
    },
    // 供应商付款汇总表-明细列表-统计
    getFinanceSupplierPaymentDetailCount(data: any){
        return ajax({
            method: 'get',
            url: `report/supplier-pay-detail-sum`,
            data
        })
    },
    // 供应商付款汇总表-明细列表-导出
    getFinanceSupplierPaymentDetailExport(data: any){
        return ajax({
            method: 'get',
            url: `report/supplier-pay-detail-export`,
            type: "blob",
            data
        })
    },
};

export default api;